/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const NO_OP_MUTATION = gql`
  mutation NoOpMutation {
    __typename
  }
`;

export const NO_OP_QUERY = gql`
  query NoOpQuery {
    __typename
  }
`;
